 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import LIST_OF_ILLUSTRATIONS from '@/components/list_of_illustrations'
 import PLATES from '@/components/plates'
 import ACK from '@/components/ack'
 import FAMILY_TREE from '@/components/family_tree'
 import MAPS from '@/components/maps'
 import INTRO from '@/components/intro'
 import CH1 from '@/components/ch1'
 import CH2 from '@/components/ch2'
 import CH3 from '@/components/ch3'
 import CH4 from '@/components/ch4'
 import CH5 from '@/components/ch5'
 import CH6 from '@/components/ch6'
 import CH7 from '@/components/ch7'
 import CH8 from '@/components/ch8'
 import CH9 from '@/components/ch9'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import EPILOGUE from '@/components/epilogue'
 import NOTES from '@/components/notes'
 import BIBLIO from '@/components/biblio'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/list_of_illustrations",
 			"name" : "list_of_illustrations",
 			"component" : LIST_OF_ILLUSTRATIONS
 		},
 		{
 			"path" : "/plates",
 			"name" : "plates",
 			"component" : PLATES
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/family_tree",
 			"name" : "family_tree",
 			"component" : FAMILY_TREE
 		},
 		{
 			"path" : "/maps",
 			"name" : "maps",
 			"component" : MAPS
 		},
 		{
 			"path" : "/intro",
 			"name" : "intro",
 			"component" : INTRO
 		},
 		{
 			"path" : "/ch1",
 			"name" : "ch1",
 			"component" : CH1
 		},
 		{
 			"path" : "/ch2",
 			"name" : "ch2",
 			"component" : CH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js